// extracted by mini-css-extract-plugin
export default {"white":"#fff","form":"OxIZ_","connector":"ktstp","filters":"BiBdE","labels":"Vvi2p","select":"kocDr","type":"Yaiq3"};